import { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from '@apollo/client/react/hoc';
import compose from 'lodash/flowRight';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import consumeAppContext from '../../consumers/app';
import { updateGroupMemberPostNotificationPreferenceMutation } from '../../apollo/groups';

const useStyles = makeStyles((theme) => ({
  button: {
    padding: theme.spacing(0, 1),
  },
  buttonIcon: {
    marginRight: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  buttonText: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const GroupPostNotificationPreferenceToggle = (props) => {
  const {
    group: { membership },
    isLoggedIn,
    updateGroupMemberPostNotificationPreference
  } = props;
  const [submitting, setSubmitting] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  if (!isLoggedIn || !membership) {
    return null;
  }

  function onClick(preference) {
    return () => {
      setAnchorEl(null);
      setSubmitting(true);
      updateGroupMemberPostNotificationPreference({
        variables: {
          id: membership.id,
          preference
        }
      }).then(() => setSubmitting(false));
    };
  }

  return (
    <Fragment>
      <Button
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
        disabled={submitting}
        aria-controls="group-post-notification-preference-menu"
        aria-haspopup="true"
        color="primary"
        // variant="outlined"
        className={classes.button}
      >
        {membership.postNotificationPreference === 'ALL' && (
          <Fragment>
            <NotificationsActiveIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>All New Posts and Comments</span>
          </Fragment>
        )}
        {membership.postNotificationPreference === 'FOLLOWING' && (
          <Fragment>
            <NotificationsActiveIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>New Posts</span>
          </Fragment>
        )}
        {membership.postNotificationPreference === 'NONE' && (
          <Fragment>
            <NotificationsNoneIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>Unsubscribed</span>
          </Fragment>
        )}
      </Button>
      <Menu
        id="group-post-notification-preference-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <MenuItem
          onClick={onClick('FOLLOWING')}
          disabled={membership.postNotificationPreference === 'FOLLOWING'}
        >
          Subscribe to posts
        </MenuItem>
        <MenuItem
          onClick={onClick('ALL')}
          disabled={membership.postNotificationPreference === 'ALL'}
        >
          Subscribe to posts and comments
        </MenuItem>
        <MenuItem
          onClick={onClick('NONE')}
          disabled={membership.postNotificationPreference === 'NONE'}
        >
          Unsubscribe from posts
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

GroupPostNotificationPreferenceToggle.propTypes = {
  group: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  updateGroupMemberPostNotificationPreference: PropTypes.func
};

export default compose(
  consumeAppContext,
  graphql(updateGroupMemberPostNotificationPreferenceMutation, {
    name: 'updateGroupMemberPostNotificationPreference'
  })
)(GroupPostNotificationPreferenceToggle);
